// removed by extract-text-webpack-plugin
module.exports = {"profileView":"profileView___1kIvx","profileImg":"profileImg___kcWOf","profileText":"profileText___3jMOq","image":"image___1JGJF","open-menu":"open-menu___1cN1B","dropdown":"dropdown___xX3Ok"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileUser/profile-user.module.scss
// module id = 1026
// module chunks = 82